import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const Auth0Icon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 256 285"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M220.412455,0 L127.996566,0 L156.558919,89.0059529 L248.974808,89.0059529 L174.20451,142.083429 L202.77514,231.594251 L202.77514,231.594251 C250.903243,196.534811 266.628676,143.473888 248.983084,89.0059529 L220.412455,0 Z M7.01832414,89.0059529 L99.4342131,89.0059529 L127.996566,0 L35.5889536,0 L7.01832414,89.0059529 L7.01832414,89.0059529 C-10.6355439,143.473888 5.09816596,196.534811 53.2262686,231.594251 L53.2262686,231.594251 L81.7886215,142.083429 L7.01832414,89.0059529 Z M53.2262686,231.594251 L127.996566,284.564132 L202.766863,231.594251 L127.996566,177.747056 L53.2262686,231.594251 Z"
      fill="currentColor"
    />
  </svg>
)
const ForwardRef = forwardRef(Auth0Icon)
export { ForwardRef as ReactComponent }
